import React from 'react';
import { motion } from 'framer-motion';
const moments = [{
  title: 'Dinner Parties',
  copy: 'The dessert that ends the evening — and starts the conversation.'
}, {
  title: 'Birthdays',
  copy: "A quietly stunning centerpiece for the year's sweetest milestone."
}, {
  title: 'Anniversaries',
  copy: 'Soft, rich, and slow — a love language served in slices.'
}, {
  title: 'Host Gifts',
  copy: "Arrive with something they'll talk about long after you leave."
}, {
  title: 'Holiday Tables',
  copy: 'Tradition, refined. A new ritual worth keeping.'
}, {
  title: 'Private Events',
  copy: 'A small-batch indulgence for moments that feel curated.'
}];
export function PerfectFor() {
  return <section id="perfect-for" className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-172">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="max-w-3xl" data-id="element-174">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-175">
            <span className="w-10 h-px bg-caramel/40" data-id="element-176" />
            Occasions
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-177">
            For the Moments
            <br data-id="element-178" />
            <span className="italic font-extralight" data-id="element-179">People Remember.</span>
          </h2>
        </motion.div>

        <div className="mt-24 lg:mt-32 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-2 lg:gap-y-4" data-id="element-180">
          {moments.map((m, i) => <motion.div key={m.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7,
          delay: i % 3 * 0.1
        }} className="group py-10 border-t border-cream/10" data-id="element-181">
              <div className="flex items-baseline gap-4 mb-6" data-id="element-182">
                <span className="font-serif italic text-caramel text-sm" data-id="element-183">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl text-cream font-light tracking-[-0.01em] group-hover:italic transition-all duration-500" data-id="element-184">
                {m.title}
              </h3>
              <p className="mt-4 text-cream/55 leading-[1.7] text-[14px] max-w-xs" data-id="element-185">
                {m.copy}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}